export const LOCAL_STORAGE_INITIAL_STATE: Record<string, any> = {};
export const LOG_LOCAL_STORAGE_KEY = '[LocalStorageStore]';
